import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';

// Shared two-column frame for the info tabs: copy on the left, media on the right
const PDPInfoSectionLayout = t0 => {
  const $ = _c(10);
  const {
    heading,
    children,
    aside: t1
  } = t0;
  const aside = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== heading) {
    t2 = !!heading && <h3 className="text-base font-bold text-gray mt-0 mx-0 mb-6">{heading}</h3>;
    $[0] = heading;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className="flex-1 min-w-0">{t2}{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== aside) {
    t4 = !!aside && <div className="flex-1 min-w-0">{aside}</div>;
    $[5] = aside;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-row gap-12 max-[767px]:flex-col max-[767px]:gap-6">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
PDPInfoSectionLayout.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.node,
  aside: PropTypes.node
};
export default PDPInfoSectionLayout;